module.exports = __webpack_public_path__ + "media/images/pin-5e9e19fe238496a095f0ca98d9e4c159.svg";